import { render, staticRenderFns } from "./PageErrorNotFound.vue?vue&type=template&id=408a11eb&scoped=true&"
import script from "./PageErrorNotFound.vue?vue&type=script&lang=js&"
export * from "./PageErrorNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PageErrorNotFound.vue?vue&type=style&index=0&id=408a11eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408a11eb",
  null
  
)

export default component.exports